<template>
  <div>
    <div class="spinner-wrapper">
        <div class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
        </div>
    </div>

    <nav-section></nav-section>

    <!-- Details 1 -->
    <div style="margin: 87px 0 0 0; padding: 1em;">
        <div class="container">
            <div class="row">
              <div class='col' style="padding:1em;">
                <h3>Frequently Asked Questions</h3>
              </div>
            </div>
        </div>
    </div>

    <!-- <div class="website-body">
        <div class="container">
            <div v-for="item in questions" :key="item.question" class="row">
              <div class='col' style="padding:1em;">
                <span style="font-size:2em;"></span><br/>
                <p style="font-size:1.2em;"></p>
              </div>
            </div>
        </div>
    </div> -->

    <div class="website-body accordion" id="accordionExample">
      <div v-for="item in questions" :key="item.question" class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#' + item.id" aria-expanded="false" :aria-controls="item.id">
            {{item.question}}
          </button>
        </h2>
        <div :id="item.id" class="accordion-collapse collapse" :aria-labelledby="item.id" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <strong>{{item.answer}}</strong>
          </div>
        </div>
      </div>
    </div>

    <copyright-section></copyright-section>
  </div>
</template>

<script>
import NavSection from './NavSection'
import CopyrightSection from './CopyrightSection'

export default {
  name: 'FAQPage',
  methods: {

  },
  data () {
    return {
      questions: [
        {
          'question': 'How quickly are orders processed?',
          'answer': 'Orders are processed in the order they are recieved. Our wood items ship within 1-2 business days. Our 3d printed items in plastic are made to order and ship within 5-10 business days.',
          'id': 'one'
        },
        {
          'question': 'How are orders packaged?',
          'answer': 'All orders are packaged by hand. They are first wrapped in tissue paper, then bubble wrap and placed in a bubble mailer. Larger orders or orders of glass/ceramics are packaged in an appropriate sized box and protected.',
          'id': 'two'
        },
        // {
        //   'question': 'What type of plastic is used?',
        //   'answer': 'All of ',
        //   'id': 'three'
        // },
        // {
        //   'question': 'Where does the wood come from?',
        //   'answer': 'TODO',
        //   'id': 'four'
        // },
        {
          'question': 'Why types of wood do you offer?',
          'answer': 'Currently we offer our products in Maple, Cherry, Black Walnut, Paduak, Purple Heart, Monkey Pod, Wenge and Bloodwood. Wood is always subject to availability and we may not always have stock. Feel free to reach out to us if there is something specific you are looking for.',
          'id': 'five'
        },
        {
          'question': 'Do you do custom orders?',
          'answer': 'We love doing custom orders and hearing your ideas! Please contact us about it! Just note that depending on other projects and the complexity of the custom order we may not always take them on.',
          'id': 'six'
        }
      ]
    }
  },
  components: {
    NavSection,
    CopyrightSection
  }
}
</script>


// WEBPACK FOOTER //
// src/components/FAQPage.vue